exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".daily-article .article-button[data-v-5fdd1670] {\n  font-size: 1.2rem !important;\n}\n.daily-article .ant-card-body[data-v-5fdd1670] {\n  padding: 18px !important;\n}\n.daily-article .ant-card-head[data-v-5fdd1670] {\n  padding: 0 1rem;\n}\n.daily-article .ant-card-meta[data-v-5fdd1670] {\n  margin-bottom: 1rem;\n}\n.daily-article .article-content p[data-v-5fdd1670] {\n  word-wrap: break-word;\n  word-break: break-all;\n  text-overflow: initial;\n  white-space: normal;\n  font-size: 0.9rem !important;\n  margin-bottom: 0.8rem;\n}\n", ""]);

// exports
